/** @format */
export default {
  onTableData(o: any, resData: any) {
    const totals = resData.total;

    if (totals != null) {
      o.push({
        totalAmount: totals.totalAmount, //应收
        paidAmount: totals.paidAmount, //实收
        discountAmount: totals.discountAmount, //优惠金额
        unpaidAmount: totals.unpaidAmount, //应收未收
        specialAmount: totals.specialAmount, //减免金额
        pkUnCollectedId: 'I am total',
        parkName: '合计',
        isTotalRow: true
      });
      // this.pageSize = this.defaultPageSize - 0 + 1
    }
    // console.log('on table data invoked', resData)
    return o;
  },
  onDetail(o: any) {
    this.reviewDescriptionOfDialog = '';
    console.log('this.detailDialogType---', this.detailDialogType);
    const basicInfo = o['基本信息'];
    const self = this;
    const tempFields = basicInfo.fields;
    basicInfo.fields = tempFields.filter(
      item => !item.label.startsWith('审核') && !(item.label.includes('收') || item.label.includes('金额'))
    );

    const oEmpty = (o[''] = o['基本信息']);
    delete o['基本信息'];
    oEmpty.fields.length = [];
    oEmpty.data = {
      ...oEmpty.data,
      computedUncollectedAmount: Math.max(oEmpty.data.uncollectedAmount, oEmpty.data.cancelAmount).toFixed(2)
    };
    oEmpty.fields = oEmpty.fields.concat([
      {
        label: '车牌号',
        prop: 'plate'
      },
      {
        label: '补缴金额',
        prop: 'computedUncollectedAmount'
        // prop: 'uncollectedAmount',
      }
    ]);

    const payWaySelectCompData = this.filterParam.adapterDataForViewModel.payBackWayHandler.list;
    // label: "现金"
    // value: "00"

    oEmpty.fields.push({
      label: '补缴方式',
      render: () => {
        return (
          <a-select
            defaultValue={self.filterParam.adapterDataForViewModel.payBackWayHandler.model}
            onchange={self.filterParam.adapterDataForViewModel.payBackWayHandler.onChange}
          >
            {self.filterParam.adapterDataForViewModel.payBackWayHandler.list.map(item => {
              return <a-select-option value={item.value}>{item.label}</a-select-option>;
            })}
          </a-select>
        );
      }
    });

    // let reviewInfo
    //
    // if ('DETAIL' == this.detailDialogType) {
    //   reviewInfo = {
    //     fields: tempFields.filter(item => item.label.startsWith('审核')),
    //     data: basicInfo.data,
    //   }
    // }
    //
    // if ('REVIEW' == this.detailDialogType) {
    //   reviewInfo = {
    //     fields: [
    //       {
    //         label: '审核意见',
    //         render(c) {
    //           return c(
    //             'a-textarea',
    //             {
    //               attrs: {
    //                 placeholder: '请输入审核意见',
    //               },
    //
    //               on: {
    //                 change(e) {
    //                   self.reviewDescriptionOfDialog = e.target.value
    //                   console.log('this is on change--:', e.target.value)
    //                 },
    //               },
    //             },
    //             '',
    //           )
    //         },
    //       },
    //     ],
    //     data: basicInfo.data,
    //   }
    // }
    // console.log('basicInfo.fields--:', basicInfo.fields)

    // let imgNode = basicInfo.fields.find(item => item.prop === 'img')
    // imgNode.render = function(c) {
    //   return c('img', {
    //     attrs: {
    //       src: basicInfo.data[imgNode.prop],
    //     },
    //     on: {
    //       click: () => {
    //         self.reviewImages(basicInfo.data)
    //       },
    //     },
    //     style: {
    //       'max-width': '50%',
    //     },
    //   })
    // }

    return {
      ...o

      // 收费信息: {
      //   data: basicInfo.data,
      //   fields: tempFields.filter(item => item.label.includes('收') || item.label.includes('金额')),
      // },
      // 审核信息: reviewInfo,
    };
  },
  onSearch(o: any) {
    this.log('on search invoked');
    return {
      parkIds: o.parkIds instanceof Array ? o.parkIds.join(',') : o.parkIds,
      currPage: this.current,
      // plate: o.adapterDataForViewModel.plateHead + o.adapterDataForViewModel.plateTail,
      // userId: '',
      pageSize: this.pageSize
    };
  }
};
